import React, { createContext, useCallback, useRef } from 'react';
import useKeydownEvent from '@atlaskit/ds-lib/use-keydown-event';
import handleFocus from '../utils/handle-focus';
/**
 *
 *
 * Context provider which maintains the list of focusable elements and a method to
 * register new menu items.
 * This list drives the keyboard navgation of the menu.
 *
 */

export var FocusManagerContext = /*#__PURE__*/createContext({
  menuItemRefs: [],
  registerRef: function registerRef(ref) {}
});
/**
 * Focus manager logic
 */

var FocusManager = function FocusManager(_ref) {
  var children = _ref.children;
  var menuItemRefs = useRef([]);
  var registerRef = useCallback(function (ref) {
    if (ref && !menuItemRefs.current.includes(ref)) {
      menuItemRefs.current.push(ref);
    }
  }, []);
  useKeydownEvent(handleFocus(menuItemRefs.current));
  var contextValue = {
    menuItemRefs: menuItemRefs.current,
    registerRef: registerRef
  };
  return /*#__PURE__*/React.createElement(FocusManagerContext.Provider, {
    value: contextValue
  }, children);
};

export default FocusManager;